import type React from 'react'
import type { JSX } from 'react'
import type {
  SkeletonUnitAlignItems,
  SkeletonUnitAspectRatio,
  SkeletonUnitCorners,
  SkeletonUnitDirection,
  SkeletonUnitJustifyContent,
  SkeletonUnitMargin,
  SkeletonUnitPadding,
  SkeletonUnitWrap,
} from './SkeletonUnit.h'

import { SkeletonUnitSC } from './SkeletonUnit.styled'

export interface ISkeletonUnitProps {
  children?: React.ReactNode
  width?: string
  height?: string
  direction?: SkeletonUnitDirection
  justifyContent?: SkeletonUnitJustifyContent
  alignItems?: SkeletonUnitAlignItems
  flexBasis?: string
  flexGrow?: string
  flexShrink?: string
  flexWrap?: SkeletonUnitWrap
  corners?: SkeletonUnitCorners
  paddings?: SkeletonUnitPadding
  margins?: SkeletonUnitMargin
  aspectRatio?: SkeletonUnitAspectRatio
}

export const SkeletonUnit = ({
  children,
  width,
  height,
  direction,
  justifyContent,
  alignItems,
  flexBasis,
  flexGrow,
  flexShrink,
  flexWrap,
  corners,
  paddings,
  margins,
  aspectRatio,
}: ISkeletonUnitProps): JSX.Element => (
  <SkeletonUnitSC
    width={width}
    height={height}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    flexWrap={flexWrap}
    corners={corners}
    paddings={paddings}
    margins={margins}
    aspectRatio={aspectRatio}
  >
    {children}
  </SkeletonUnitSC>
)
